import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from "react-i18next";

import withStyles from "@material-ui/core/styles/withStyles";

// Own components
import TicketListTable from "../../tables/Tickets/TicketListTable";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.jsx";
import Position from "components/Position";

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Badge from "../../components/Badge/Badge";
import AddIcon from '@material-ui/icons/Add';

import {NavLink} from "react-router-dom";
import TablePagination from '../../pagination/table/TablePagination';
import useGlobal from '../../store';
import auth from '../../utils/auth';
import ReportFiltersModal from "../../modals/ReportsFiltersModal";
import AlertDelayModal from "../../modals/AlertDelayModal";
import SecurityAlertsModal from '../../modals/SecurityAlertsModal';
import TrafficLightConfigModal from '../../modals/TrafficLightConfigModal';
import { Chip, debounce, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from '@material-ui/core';
import customSelectStyle from "../../assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import { Autocomplete } from '@material-ui/lab';

const TicketListView = ({
  classes, 
  tickets, 
  paginationAction, 
  filters, 
  plan, 
  generateReport,
  archive,
  changeStatus,
  allTickets,
  setSelectedTickets,
  isLoadingTickets
}) => {
  const { t, } = useTranslation('tickets');

  const ticketsCount = plan ? parseInt(plan?.features?.tickets) : 50;
  const currentTickets = tickets ? tickets?.length : 50;

  const disabledTickets = ticketsCount <= currentTickets;
  const reportCount = (ticketsCount - currentTickets) >= 0 ? ticketsCount - currentTickets : 0;

  const [session] = useGlobal(
    (state) => state.session,
    (actions) => actions
  );
  const [modalStatus, setModalStatus] = useState({
    open: false,
    reportConfig: {}
  });

  const [modalDelayAlert, setModalDelayAlert] = useState({
    open: false,
    ticket: null,
    app: null
  });

  const [modalSecurity, setModalSecurity] = useState({
    open: false,
    ticket: null,
  });

  const [modalTrafficLight, setModalTrafficLight] = useState({
    open: false,
    ticket: null,
    app: null,
  });


  const hasPermission = (permission) => {
    if ( session.user && !auth.hasPermission(permission, session.permissions)) return false;
    return true;
  };

  const [ticketsOptions, setTicketsOptions] = useState([]);
  const [ticketsOptionsSelected, setTicketsOptionsSelected] = useState([]);

  useEffect(() => {
    console.log("allTickets", allTickets);
    if(allTickets && allTickets.length && ticketsOptions.length === 0) {
      const incidents = allTickets.map((ticket => ({ value: ticket._id, label: ticket.name})))
      try {
        const storedSelection = sessionStorage.getItem("ticket-ids-selected");
  
        if (storedSelection) {
          const parsedSelection = JSON.parse(storedSelection);
          
          if (Array.isArray(parsedSelection) && parsedSelection.length > 0) {
            const validSelectedOptions = parsedSelection.reduce((acc, selected) => {
              const exists = incidents.find(option => option.value === selected);
              return exists ? [...acc, exists] : acc;
            }, []);
            
            if (validSelectedOptions.length > 0) {
              setTicketsOptionsSelected(validSelectedOptions);
            }
          }
        }
      } catch (error) {
        
      }
      setTicketsOptions(incidents)
    }
  }, [allTickets])

  const changeOptions = (items) => {
    const ids = items.map((item => item.value))
    setSelectedTickets(ids);
  }

  const changeOptionsRef = useRef(changeOptions);
  changeOptionsRef.current = changeOptions;

  const debouncedChangeOptions = useRef(
    debounce((ids) => changeOptionsRef.current(ids), 1000)
  ).current;

  useEffect(() => {
    return () => {
      debouncedChangeOptions.clear();
    };
  }, []);
  return (
    <div className="Tickets">
      {/*TICKETS TABLE*/}
      <React.Fragment>
        <Card>
          <CardHeader color="info" text>
            <GridContainer>
              <GridItem xs={6}>
                <CardText color="info">
                  <h4 className={classes.cardTitle}>{t("tickets.title")}</h4>
                </CardText>
              </GridItem>
              <GridItem xs={6}>
                <Position right>
                  <Badge color={"success"}>
                    {typeof tickets !== "undefined" && Array.isArray(tickets)
                      ? tickets.length
                      : 0}{" "}
                    {t("tickets.title")}
                  </Badge>
                  <NavLink
                    to={
                      !disabledTickets || !hasPermission("ticketsCreated")
                        ? "/tickets/new"
                        : "#"
                    }
                  >
                    <Button
                      justIcon
                      round
                      simple
                      color={"success"}
                      disabled={disabledTickets}
                    >
                      <AddIcon />
                    </Button>
                  </NavLink>
                </Position>
              </GridItem>
            </GridContainer>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12}>
                <div
                  className={`${classes.right} ${classes.cursor}`}
                  onClick={() => changeStatus()}
                >
                  <Badge color={"primary"}>
                    {filters.archived
                      ? t("tickets.viewNotArchived")
                      : t("tickets.viewArchived")}
                  </Badge>
                </div>
                {!filters.archived ? (
                  <div className={classes.right}>
                    <Badge color={"info"}>
                      {t("tickets.remaning")}: {reportCount}
                    </Badge>
                  </div>
                ) : (
                  []
                )}
              </GridItem>
              <GridItem xs={12}>
                <div className={classes.right}>
                  <Typography variant="p" className={classes.paddingText}>
                    {t("tickets.dateRangeInfo")}
                  </Typography>
                  <Button
                    size="sm"
                    color="info"
                    onClick={() => {
                      setModalStatus({
                        open: true,
                        reportConfig: {},
                      });
                    }}
                  >
                    {t("tickets.generateReport")}
                  </Button>
                </div>
              </GridItem>
              <GridItem xs={12}>
                <div className={classes.left}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <Autocomplete
                    limitTags={6}
                    multiple
                    filterSelectedOptions
                    disableCloseOnSelect
                    id="autocomplete-tickets"
                    options={ticketsOptions || []}
                    getOptionLabel={(suggestion) =>
                      suggestion.label
                    }
                    value={ticketsOptionsSelected}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => {
                        return (
                          <Chip
                            size="small"
                            label={option.label}
                            {...getTagProps({ index })}
                          />
                        );
                      })
                    }
                    onChange={(event, value) => {
                      setTicketsOptionsSelected(value)
                      debouncedChangeOptions(value)
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label={t("tickets.title")}
                        fullWidth
                        margin="normal"
                        placeholder="Filtrar por tipo de incidencia"
                      />
                    )}
                  />
                </FormControl>
                </div>
              </GridItem>
              <GridItem xs={12}>
                <TablePagination
                  data={tickets ? tickets : []}
                  paginationAction={paginationAction}
                  filter={filters}
                />
                <TicketListTable
                  setModalDelayAlert={setModalDelayAlert}
                  setModalSecurity={(open) => {
                    setModalSecurity(open);
                  }}
                  setModalTrafficLight={setModalTrafficLight}
                  data={tickets || []}
                  archive={archive}
                  isLoadingTickets={isLoadingTickets}
                />
              </GridItem>
            </GridContainer>
            <ReportFiltersModal
              modalStatus={modalStatus}
              setModalStatus={setModalStatus}
              generateReport={generateReport}
            />

            <AlertDelayModal
              modalStatus={modalDelayAlert}
              setModalStatus={setModalDelayAlert}
              generateReport={generateReport}
            />

            <SecurityAlertsModal
              modalStatus={modalSecurity}
              setModalStatus={setModalSecurity}
            />

            <TrafficLightConfigModal
              modalStatus={modalTrafficLight}
              setModalStatus={setModalTrafficLight}
            />
          </CardBody>
        </Card>
      </React.Fragment>
    </div>
  );
};

TicketListView.propTypes = {
  tickets: PropTypes.array.isRequired
};

const styles = theme => ({
  center: {
    textAlign: "center"
  },
  right: {
    float: "right",
  },
  left: {
    float: "left",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 400,
    maxWidth: 500,
  },
  cursor: {
    cursor: 'pointer'
  },
  paddingText: {
    padding: '10px'
  },
  ...customSelectStyle
});

export default withStyles(styles)(TicketListView);
